


























export default {
  name: "MultipleSelectFilter",
  props: ['options', 'value', 'clear', 'confirm', 'defaultValue'],
  methods: {
    onChange(val?: any) {
      // @ts-ignore
      this.$emit('change', val || this.defaultValue);
    }
  }
}
